import { render, staticRenderFns } from "./AddReportDefinition.vue?vue&type=template&id=1ca12214"
import script from "./AddReportDefinition.vue?vue&type=script&lang=js"
export * from "./AddReportDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports